import { render, staticRenderFns } from "./goods_add_and_edit.vue?vue&type=template&id=4c21b16e&scoped=true&"
import script from "./goods_add_and_edit.vue?vue&type=script&lang=jsx&"
export * from "./goods_add_and_edit.vue?vue&type=script&lang=jsx&"
import style0 from "./goods_add_and_edit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./goods_add_and_edit.vue?vue&type=style&index=1&id=4c21b16e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c21b16e",
  null
  
)

export default component.exports